import {
  useCompanyUserCompanyTagsLazyQuery,
  CompanyTagQueryFilter,
  CompanyTagQueryPagination,
} from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { UseCompanyTagsType, CompanyTagsResultType } from './types';

const useCompanyTags = (): UseCompanyTagsType => {
  const [query, { data, called, loading, networkStatus, fetchMore, refetch }] = useCompanyUserCompanyTagsLazyQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const request = async (filters: CompanyTagQueryFilter, pagination: CompanyTagQueryPagination) => {
    const result = await query({ variables: { filters, pagination } });
    return result;
  };

  const loadMore = async (filters: CompanyTagQueryFilter, pagination: CompanyTagQueryPagination) => {
    await fetchMore({
      variables: { filters, pagination },
      updateQuery: (prev, { fetchMoreResult }) => {
        const prevResult = prev?.companyTagPaginationQuery?.result || [];
        const newResult = fetchMoreResult?.companyTagPaginationQuery?.result || [];
        const existingIds = new Set(prevResult.map((t) => t.id));

        return {
          ...prev,
          companyTagPaginationQuery: {
            ...prev?.companyTagPaginationQuery,
            ...fetchMoreResult?.companyTagPaginationQuery,
            result: [...prevResult, ...newResult.filter((t) => !existingIds.has(t.id))],
          },
        };
      },
    });
  };

  const result: CompanyTagsResultType = {
    loading,
    called,
    networkStatus,
    data: {
      tags: data?.companyTagPaginationQuery.result?.map((tag) => ({ ...tag })),
      paginationInfo: data?.companyTagPaginationQuery.paginationInfo,
    },
    loadMore,
    refetch,
  };

  return [request, result];
};

export default useCompanyTags;
